<script lang="ts">
  import { HeadingLarge } from '@athena-lib/Text';
  import { PageSection } from '@stickerapp-org/athena/Page';
  import type { SupportBlock } from '@storyblok-types';
  import { StoryblokComponent, storyblokEditable } from '@storyblok/svelte';
  import Stack from '@athena-lib/Stack/Stack.svelte';
  import StackItem from '@athena-lib/Stack/StackItem.svelte';
  import { isRichTextEmpty } from '../RichText/types';
  import { RichText } from '../RichText';
  const { blok }: { blok: SupportBlock } = $props();

  const hasQuestion = $derived(!!blok.question);
  const hasAnswer = $derived(!isRichTextEmpty(blok.answer));
  const body = $derived(blok.body ?? []);
  const hasBody = $derived(body.length > 0);
</script>

{#if hasQuestion || hasAnswer}
  <PageSection action={storyblokEditable} actionArg={blok} class="flex align-middle">
    <Stack class="max-w-text-max">
      {#if hasQuestion}
        <StackItem>
          <HeadingLarge>{blok.question}</HeadingLarge>
        </StackItem>
      {/if}
      {#if hasAnswer}
        <StackItem>
          <RichText size="large" text={blok.answer} />
        </StackItem>
      {/if}
    </Stack>
  </PageSection>
{/if}

{#if hasBody}
  <PageSection ySpace={{ top: 'none', bottom: 'none' }}>
    <hr />
  </PageSection>
  {#each body as subBlok}
    <StoryblokComponent blok={subBlok}></StoryblokComponent>
  {/each}
{/if}
